/* eslint-disable react/require-default-props */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import {
  Col, Dropdown, Row, Card,
} from 'react-bootstrap';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Avatar from '../../common/Avatar';
import { quickLinks } from '../../data/quickLinks';
import { CiatAppContext } from '../../../../providers';

function NineDotMenu() {
  const [show, setShow] = useState(null);
  const { currentUser } = useContext(CiatAppContext);
  const [avatarImg, setAvatarImage] = useState();

  useEffect(() => {
    setAvatarImage(
      (typeof currentUser.profile?.s_avatar) === 'string'
          && currentUser.profile.avatar && ('filename' in currentUser.profile.avatar)
        ? currentUser.profile.s_avatar : null,
    );
  }, [currentUser]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      // eslint-disable-next-line no-unused-expressions
      window.innerWidth < 1200 && setShow(false);
    });
  }, []);

  return (
    <Dropdown navbar as="li" show={show} onToggle={() => setShow(!show)}>
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="nav-link px-2"
      >
        {/* <span className="nine-dots"></span> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="37"
          viewBox="0 0 16 16"
          fill="none"
        >
          <circle cx="2" cy="2" r="2" fill="#6C6E71" />
          <circle cx="2" cy="8" r="2" fill="#6C6E71" />
          <circle cx="2" cy="14" r="2" fill="#6C6E71" />
          <circle cx="8" cy="8" r="2" fill="#6C6E71" />
          <circle cx="8" cy="14" r="2" fill="#6C6E71" />
          <circle cx="14" cy="8" r="2" fill="#6C6E71" />
          <circle cx="14" cy="14" r="2" fill="#6C6E71" />
          <circle cx="8" cy="2" r="2" fill="#6C6E71" />
          <circle cx="14" cy="2" r="2" fill="#6C6E71" />
        </svg>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="dropdown-menu-card dropdown-caret dropdown-caret-bg"
        show={show}
        style={{ right: 0, left: 'auto' }}
      >
        <Card
          className="dropdown-menu-end shadow-none"
          style={{ minWidth: '16rem' }}
        >
          {/* /!*  /!* <SimpleBarReact className="nav-quick-links"> *!/ *!/ */}
          <Card.Body>
            <Row className="text-center g-3">
              {quickLinks.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
                <QuickLinkItem key={index} {...item} {...index} avatarImg={avatarImg} />
              ))}
              {/* <Col xs={12}> */}
              {/*  <Link to="#!" className="btn btn-outline-primary btn-sm mt-4"> */}
              {/*    Show more */}
              {/*  </Link> */}
              {/* </Col> */}
            </Row>
          </Card.Body>
          {/*  /!* </SimpleBarReact> *!/ */}
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
}

function QuickLinkItem({
  avatar, avatarText, avatarImg, img, title, link, hr,
}) {
  return (
  // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {hr ? (
        <Col xs={12}>
          <hr className="my-3 mx-n3 text-200" />
        </Col>
      ) : (
        <Col xs={4}>
          <a
            className="d-block hover-bg-200 rounded-3 text-decoration-none p-1"
            target="_blank"
            rel="noopener noreferrer"
            href={link || '#!'}

          >
            {avatar && <Avatar src={avatarImg} icon={faUser} size="xl" />}
            {avatarText && (
              <Avatar
                isExact
                name={avatarText}
                size="xl"
                mediaClass="fs-2 bg-soft-primary text-primary"
              />
            )}
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            {img && (
            <img
              src={img}
              width={30}
              height={30}
              alt={title}
              placeholder={title}
              className="rounded-circle"
            />
            )}
            <p
              className={classNames(
                'mb-0 fw-medium text-800 text-truncate fs--2',
                {
                  'pt-1': img,
                },
              )}
            >
              {title}
            </p>
          </a>
        </Col>
      )}
    </>
  );
}

QuickLinkItem.propTypes = {
  avatar: PropTypes.bool,
  avatarImg: PropTypes.string,
  avatarText: PropTypes.string,
  img: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  hr: PropTypes.bool,
};

export default NineDotMenu;
